<template>
    <div class="container">
        <div style="margin-right: 15%;width: 20%;float: left">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm"
                     label-position="left" label-width="0px" class="demo-ruleForm login-container">
                <h3 class="title">商家代注册</h3>
                <p class="title">代替客户注册，注册完成后将帐号密码交付客户。</p>
                <el-form-item prop="account">
                    <el-input type="text" clearable v-model="ruleForm.account" auto-complete="off"
                              placeholder="设置商家账号"></el-input>
                </el-form-item>
                <el-form-item prop="nickname">
                    <el-input type="text" clearable v-model="ruleForm.nickname" auto-complete="off"
                              placeholder="设置商家账号昵称"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input type="password" clearable v-model="ruleForm.password" auto-complete="off"
                              placeholder="设置登录密码"></el-input>
                </el-form-item>
                <el-form-item prop="password2">
                    <el-input type="password" clearable v-model="ruleForm.password2" auto-complete="off"
                              placeholder="请再次输入登录密码"></el-input>
                </el-form-item>
                <el-form-item style="width:100%;">
                    <el-button type="primary" style="width:100%;" @click.native.prevent="editSubmit" :loading="loading">
                        注册
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-right: 15%;width: 20%;float: left">
            <h3 class="title">商家自行注册</h3>
            <p class="title">通过该链接或二维码注册的用户自动划为本客户。</p>
            <p class="title">注册链接地址：</p>
            <el-button style="width:100%;" @click.native.prevent="copyUrl">{{user.reg_add}}</el-button>
            <p class="title">注册二维码：</p>
            <el-image style="width: 300px;" :src="logo"></el-image>
        </div>
    </div>
</template>

<script>
    import util from '../../common/js/util'
    import $ from "jquery";
    import store from "../../vuex/store";
    //import NProgress from 'nprogress'

    export default {
        data() {
            return {
                filters: {
                    name: ''
                },
                user: {},
                logo: '',
                ruleForm: {
                    account: "",
                  nickname: "",
                    password: "",
                    password2: ""
                },
                rules: {
                    name: [
                        {required: true, message: '请输入姓名', trigger: 'blur'}
                    ],
                  nickname: [
                        {required: true, message: '请输入昵称', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'}
                    ],
                    password2: [
                        {required: true, message: '请再次输入密码', trigger: 'blur'}
                    ]
                },
                loading: false
            }
        },
        methods: {
            getUserInfo() {
                let _this = this;
                _this.$Api.getUserInfo().then(res => {
                  _this.user = res;
                  _this.getRegaddQrcode();
                })
                    .catch(err => {
                        _this.logining = false;
                        _this.$message({
                            message: err,
                            type: "error"
                        });
                    });
            },
            getRegaddQrcode() {
                let _this = this;
                let para = {
                    dealer_code: _this.user.dealer_code
                };
                $.ajax({
                    url: store.state.api + '/user/regadd/qrcode',
                    type: "post",
                    data: para,
                    xhrFields: {responseType: "arraybuffer"},
                    headers: {
                        'token': JSON.parse(sessionStorage.getItem('user')).token,
                    },
                    success: function (response) {
                        _this.logo = 'data:image/png;base64,' + btoa(new Uint8Array(response).reduce((data, byte) => data + String.fromCharCode(byte), ''));
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        _this.$message({
                            message: XMLHttpRequest,
                            type: "error"
                        });
                    }
                });
            },
            copyUrl() {
                let aux = document.createElement("input");
                aux.setAttribute("value", this.user.reg_add);
                document.body.appendChild(aux);
                aux.select();
                document.execCommand("copy");
                document.body.removeChild(aux);
                this.$message('已复制到粘贴板');
            },
            editSubmit() {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        let para = Object.assign({}, this.ruleForm);
                        if (para.password != para.password2) {
                            this.$message({
                                message: '两次密码不一致',
                                type: 'error'
                            });
                            return;
                        }
                        ;
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            //NProgress.start();
                            this.loading = true;
                            this.$Api.businessRegist(para).then((res) => {
                                this.loading = false;
                                this.$message({
                                  message: '注册成功',
                                  type: 'success'
                                });
                                this.$refs['ruleForm'].resetFields();

                                //NProgress.done();

                            })
                                .catch(err => {
                                    this.loading = false;
                                    this.$message({
                                        message: err,
                                        type: "error"
                                    });
                                });
                        });
                    }
                });
            },

        },
        mounted() {
            this.getUserInfo();
        }
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// MerchantRegist.vue?25791fa6